<template>
  <div
    id="app"
    class="flex flex-col min-h-screen"
    :class="`page__${$route.name}`"
  >
    <AppHeader v-if="allowApplicationLifeCycles" />
    <div class="flex-grow">
      <div
        v-show="showBannerV2"
        id="exp-banner-v2"
      />
      <router-view v-if="allowApplicationLifeCycles" />
    </div>
    <AppLoader
      v-if="!allowApplicationLifeCycles || loading"
      modal
    />
    <AppFooter
      v-if="allowApplicationLifeCycles"
      :mgo-url="$options.mgoUrl"
    />
    <div
      v-if="flagRecaptchaEnabled"
      id="grecaptcha-element"
      :data-sitekey="`${getRecaptchaV3Key()}`"
      render="explicit"
      class="grecaptcha"
    />
  </div>
</template>

<script>
import { isDesktop } from './utils/deviceType';
import AppLoader from './components/AppLoader.vue';
import destinationManagerMixin from './mixins/destinationManager';
import grecaptchaMixin from './mixins/grecaptcha';

export default {
  name: 'App',
  components: {
    AppHeader: () => (isDesktop()
      ? import(/* webpackChunkName: "bootstrap" */ '@mgo/ui/lib/components').then((module) => {
        const { AppHeaderDesktop } = module;
        return AppHeaderDesktop;
      })
      : import(/* webpackChunkName: "bootstrap" */ '@mgo/ui/lib/components').then((module) => {
        const { AppHeaderMobile } = module;
        return AppHeaderMobile;
      })
    ),
    AppFooter: () => import(/* webpackChunkName: "bootstrap" */ '@mgo/ui/lib/components').then((module) => {
      const { AppFooter } = module;
      return AppFooter;
    }),
    AppLoader,
  },
  mixins: [
    destinationManagerMixin,
    grecaptchaMixin,
  ],
  computed: {
    showBannerV2() {
      return /confirm-order/gi.test(this.$route.path);
    },
    allowApplicationLifeCycles() {
      return this.$route.name === 'session-unavailable'
        || Object.keys(this.$store.get('config')).length > 0;
    },
    mgoAppName() {
      const name = this.$store.get('mgoAppName');
      sessionStorage.setItem('mgoAppName', name);
      return name;
    },
    loading() {
      return this.$store.get('loading');
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$coa.coaUUID) {
          this.$setSession(this.$coa.coaUUID, this.$coa.orderUuid);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
